import React, {useState, useRef, useEffect, forwardRef, useImperativeHandle} from 'react';
import {Box, Button, IconButton, TextField, Typography, Grid} from "@mui/material";
import CustomModal from "../modal/customModal";
import CustomButtoncolor from "../custom-button/customColorButton";
import {useDispatch} from "react-redux";
import {PlayArrow} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {FormLinkData, getAllSubmittedTreatmentForms, getAllTreatmentForms} from "../../store/user/chart-form";
import Loader from "../loader/loader";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SimpleInput from '../form/simpleInput';
import CancelIcon from '@mui/icons-material/Cancel';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import { MySwal } from '../../services/utills';
import {mySwalButton} from "../../components/card-appointment/CardAppointment";
import Waveloading from '../../pages/loading/Waveloading';
import LinkModal from './LinkModal';
import Customcolorbtn from '../custom-button/customeColorCalender';
import ArticleIcon from '@mui/icons-material/Article';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from '@mui/icons-material/Search';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BarChartIcon from '@mui/icons-material/BarChart';
import SendIcon from '@mui/icons-material/Send';
import { recordSentForm, resolveFormMeta } from '../../utils/sentFormsLog';

const formRowSx = {width:'100%',background:'#F5DFEA',p:'5px 10px',borderRadius:'5px',mt:'5px',mb:'10px',display:'flex',height:'35px',alignItems:'center',cursor:'pointer',justifyContent:'space-between'};

const TreatmentFormButtonCalendar = forwardRef(({data, crmStyle, completed, fwidth, fsize, isbtn, panelMode, onPanelOpen, onPanelClose, onFormSelect}, ref) => {
    const [loading, setLoading] = useState(false)
    const [searchResults, setSearchResults] = useState([]);
    const [rescheduleModal, setRescheduleModal] = useState(false) 
    const [treatmentForm, setTreatmentForm] = useState(null)
    const [allTreatmentForms, setAllTreatmentForms] = useState([])
    const [allSubmittedForm, setAllSubmittedForm] = useState([])
    const [search, setSearch] =useState('')
    const [active, setActive] = useState(panelMode ? 0 : 4)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLinkUrl, setSelectedLinkUrl] = useState(null);
    const [panelIframeUrl, setPanelIframeUrl] = useState(null);
  
    const scrollableRef = useRef(null);
 
    const handleKeyDown = (event) => {
        if (event.key === 'ArrowDown') {
            if (scrollableRef.current) {  
                scrollableRef.current.scrollBy(0, 10);  
            }   
        }
    }     
    useEffect(() => {
        const scrollableElement = scrollableRef.current;
        if (scrollableElement) {
            scrollableElement.addEventListener('keydown', handleKeyDown);
            scrollableElement.tabIndex = "0"; 
            scrollableElement.style.outline = "none"; 
        }

        return () => {
            if (scrollableElement) {
                scrollableElement.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, []);   
  
    const openModal = (linkUrl) => {
      setSelectedLinkUrl(linkUrl);
      setIsModalOpen(true);  
    }
    
    const closeModal = () => {  
      setSelectedLinkUrl(null);
      setIsModalOpen(false);
    }   

    const handleChanges = (event) => {
        if (event.key === 'Enter') {   
          performSearch();          
        } else {   
          setSearch(event.target.value)
        }
      }  

      const performSearch = () => {
        let results = [];
        results = results.concat(filterForms(allTreatmentForms?.consent, search));
        results = results.concat(filterForms(allTreatmentForms?.customer_service_form, search));
        results = results.concat(filterForms(allTreatmentForms?.chart_form, search));
        results = results.concat(allSubmittedForm?.consent?.filter(form =>
          form.name.toLowerCase().includes(search.toLowerCase())
        ));
        
      
      }

      const filterForms = (forms, search) => {
        return forms?.filter(form =>  
          form.name.toLowerCase().includes(search.toLowerCase())         
        ) || [];      
      }

   
      const filteredForms = filterForms(allTreatmentForms?.consent, search); 
      const filteredCustomerForm = filterForms(allTreatmentForms?.customer_service_form, search);
      const filteredChartForm = filterForms(allTreatmentForms?.chart_form, search); 
      const filteredSubmitForm= allSubmittedForm?.consent?.filter(form =>
        form.name.toLowerCase().includes(search.toLowerCase())
      )
      // Submitted tab search must filter every section, not just Consent.
      const filteredSubmitCustomerForm = allSubmittedForm?.customer_service_form?.filter(form =>
        (form?.name || "").toLowerCase().includes(search.toLowerCase())
      )
      const filteredSubmitChartForm = allSubmittedForm?.chart_form?.filter(form =>
        (form?.name || "").toLowerCase().includes(search.toLowerCase())
      )

      const allFilteredForms = [
        ...filteredForms,
        ...filteredCustomerForm ,
        ...filteredChartForm,    
      ]

    const defaultId = data?.customer_id || data?.id 
    const customerId = data?.customer_id || data?.customer?.id   
    const requestType = data?.customer_id ? "CRM" : "Appointment"
   
    const dispatch = useDispatch()  
    const navigate = useNavigate()   

    const handleFetchForm = async () => {
        setLoading(true)
        let finalData = {id: defaultId, provider_id: data?.provider?.id, type: requestType}
        setTreatmentForm(finalData)
        let {payload} = await dispatch(getAllTreatmentForms(finalData))
        setLoading(false)
        setAllTreatmentForms(payload)
    }

    useImperativeHandle(ref, () => ({
        fetchAndOpen: async () => {
            setLoading(true);
            const id = data?.customer_id || data?.id;
            const type = data?.customer_id ? "CRM" : "Appointment";
            const finalData = {id, provider_id: data?.provider?.id, type};
            setTreatmentForm(finalData);
            const {payload} = await dispatch(getAllTreatmentForms(finalData));
            setLoading(false);
            setAllTreatmentForms(payload);
            onPanelOpen?.();
        }
    }), [data, dispatch, onPanelOpen]);

    const handleFormClick = (url) => {
        if (panelMode) {
            setPanelIframeUrl(url);
        } else if (onFormSelect) {
            onFormSelect(url);
        } else {
            openModal(url);
        }
    };

  const handleRowClick = async (userid,formid) => {
         let confirm = await MySwal.fire({
                           // icon: 'question',
                           title:" Email Send ?",
                           showConfirmButton: false, 
                           customClass: {
                               icon: 'custom-icon-size',
                               popup: 'custom-popup-shadow', 
                               closeButton: 'custom-close-button', 
                             },
                           showCloseButton: true,
                           // showCancelButton: true,
                           html: ( 
                             <Box>
                                {/* <Typography sx={{}}>
                                   Are you sure? you want to change appointment status to {label}.
                               </Typography> */}
                               <Box sx={{
                                 mt: 3,
                                 display: "flex",
                                 flexDirection: { lg: "row", md: "row", sm: "row", xs: "column" },
                                 gap: "12px",
                                 justifyContent: "center"
                               }}>
                                 <Button
                                   sx={{
                                     background: "#27AE60",
                                     color: "#fff",
                                     minWidth: "150px",   // fixed width
                                     border: "1px solid #27AE60",
                                     borderRadius: '10px',
                                     fontSize: '16px',
                                     px: '20px',
                                     mx: '10px',
                                     boxShadow: "none",
                                     "&:hover": {
                                       background: "#219653",
                                       color: "#fff",
                                       border: "1px solid #27AE60",
                                       boxShadow: "none",
                                     },
                                   }}
                                   onClick={() => MySwal.clickConfirm()}
                                 >
                                   YES
                                    </Button>
                                 <Button
                                   sx={{
                                     backgroundColor: "#EB5757",
                                     color: "#fff",
                                     minWidth: "150px",   // fixed width
                                     border: "1px solid #EB5757",
                                     borderRadius: '10px',
                                     fontSize: '16px',
                                     px: '20px',
                                     mx: '10px',
                                     boxShadow: "none",
                                     "&:hover": {
                                       backgroundColor: "#fff",
                                       color: "#EB5757",
                                       border: "1px solid #EB5757",
                                       boxShadow: "none",
                                     },
                                   }}
                                   onClick={() => MySwal.close()}
                                 >
                                   NO
                                 </Button>
                               </Box>
                             </Box>
                           )
                         });
        if (!!confirm?.isConfirmed) {
            const payload = {
   
                user_id: userid,
                form_id: formid
              };
          
            setLoading(true);
          const {payload: sendResult} = await dispatch(FormLinkData(payload));
          setLoading(false);

          // Log the send so it also shows under Client Forms > Submitted > Sent
          // in the CRM panel (see utils/sentFormsLog).
          const sendFailed = !sendResult
              || sendResult?.success === false || sendResult?.success === 'false'
              || !!sendResult?.errors;
          if (!sendFailed) {
              // Mail buttons sit on both the form list and the submitted list, so
              // look the form up in whichever payload holds it.
              const meta = resolveFormMeta(allTreatmentForms, formid) || resolveFormMeta(allSubmittedForm, formid);
              recordSentForm({
                  customer_id: customerId || userid,
                  link_customer_id: userid || customerId,
                  treatment_form_id: formid,
                  name: meta?.name || 'Client form',
                  url: meta?.url,
                  tag: meta?.tag,
                  customer_name: data?.customer_name || data?.name || data?.customer?.name || '',
                  customer_email: data?.email || data?.customer?.email || '',
              });
          }
           
            }else {
                setRescheduleModal(true)
            }
 }

    const handleSubmitted = async () => {
          setLoading(true) 
        setActive(3)
        let {payload}= await dispatch(getAllSubmittedTreatmentForms({id: customerId, provider_id: data?.provider?.id}))
        setLoading(false);
        setAllSubmittedForm(payload) 

    } 

    if (panelMode) {
        if (panelIframeUrl) {
            return (
                <Box sx={{
                    // Fill the host Client-Forms panel exactly like the form list does,
                    // so the opened form occupies the same area and never overlaps the
                    // appointment-detail panel / its icon rail.
                    display:'flex',
                    flexDirection:'column',
                    height:'100%',
                    width:'100%',
                    background:'#fff',
                    overflow:'hidden',
                }}>
                    <Box sx={{display:'flex',alignItems:'center',px:2,py:1.5,borderBottom:'1px solid #eef0f4',flexShrink:0,gap:1}}>
                        <IconButton size="small" onClick={() => setPanelIframeUrl(null)} sx={{color:'#A72C68','&:hover':{background:'#FAEFF5'}}}>
                            <ArrowBackIcon sx={{fontSize:18}} />
                        </IconButton>
                        <Typography sx={{flex:1,fontWeight:700,fontSize:'14px',fontFamily:'helvetica-lt-std-bold,sans-serif',color:'#1a1a2e'}}>Client Form</Typography>
                        <IconButton size="small" onClick={() => { setPanelIframeUrl(null); onPanelClose?.(); }} sx={{color:'#9A9797','&:hover':{color:'#EB5757',background:'#ffeaea'}}}>
                            <CloseIcon sx={{fontSize:18}} />
                        </IconButton>
                    </Box>
                    <iframe src={panelIframeUrl} title="client-form" style={{flex:1, border:'none', width:'100%', height:'100%'}} />
                </Box>
            );
        }
        const tagMeta = {
            Consent: { color: '#27AE60', icon: <CheckCircleIcon sx={{fontSize:12, color:'#27AE60'}} /> },
            Service: { color: '#2F80ED', icon: <CalendarMonthIcon sx={{fontSize:12, color:'#2F80ED'}} /> },
            Chart:   { color: '#F2994A', icon: <BarChartIcon sx={{fontSize:12, color:'#F2994A'}} /> },
        };
        const tabs = [
            { id: 0, label: 'All Forms', icon: <ArticleIcon sx={{fontSize:14}} /> },
            { id: 4, label: 'Consent',   icon: <CheckCircleIcon sx={{fontSize:14, color: active===4 ? '#fff' : '#27AE60'}} /> },
            { id: 1, label: 'Service',   icon: <CalendarMonthIcon sx={{fontSize:14, color: active===1 ? '#fff' : '#2F80ED'}} /> },
            { id: 2, label: 'Chart',     icon: <BarChartIcon sx={{fontSize:14, color: active===2 ? '#fff' : '#F2994A'}} /> },
            { id: 3, label: 'Submitted', icon: <SendIcon sx={{fontSize:14, color: active===3 ? '#fff' : '#2F80ED'}} /> },
        ];
        const formRow = (form, tag, onRowClick, rightExtra) => (
            <Box
                key={`${tag}-${form?.id || form?.treatment_form_id || form?.submitted_id}-${form?.name}`}
                onClick={onRowClick}
                sx={{
                    display:'flex', alignItems:'center', gap:1,
                    background:'#FAFAFC', border:'1px solid #F0F1F4',
                    borderRadius:'12px', p:'10px 12px', mb:'8px', cursor:'pointer',
                    transition:'background 0.15s, border-color 0.15s',
                    '&:hover': {background:'#FAEFF5', borderColor:'#F0CDDB'},
                }}
            >
                <ChevronRightIcon sx={{color:'#A72C68', fontSize:18, flexShrink:0}} />
                <Box sx={{width:32, height:32, borderRadius:'8px', background:'#F4DDE8', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
                    <ArticleIcon sx={{color:'#A72C68', fontSize:17}} />
                </Box>
                <Box sx={{flex:1, minWidth:0}}>
                    <Typography sx={{fontSize:'13px', fontWeight:700, color:'#1a1a2e', lineHeight:1.25, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{form?.name}</Typography>
                    {tag && (
                        <Box sx={{display:'inline-flex', alignItems:'center', gap:0.4, mt:'2px'}}>
                            {tagMeta[tag]?.icon}
                            <Typography sx={{fontSize:'11px', fontWeight:600, color: tagMeta[tag]?.color}}>{tag}</Typography>
                        </Box>
                    )}
                </Box>
                {rightExtra}
            </Box>
        );
        const mailBtn = (form) => (
            <IconButton
                size="small"
                onClick={(e)=>{e.stopPropagation(); handleRowClick(form?.customer_id, form?.treatment_form_id);}}
                sx={{color:'#A72C68', background:'#F3EEFF', borderRadius:'8px', '&:hover':{background:'#F0CDDB'}}}
            >
                <AttachEmailIcon sx={{fontSize:16}} />
            </IconButton>
        );
        const emptyMsg = (msg) => <Typography sx={{textAlign:'center', mt:'24px', color:'#9ca3af', fontSize:'13px'}}>{msg}</Typography>;
        const onFormOpen = (form) => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`);
        const onSubmittedOpen = (form) => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`);

        return (
            <Box sx={{display:'flex',flexDirection:'column',height:'100%',background:'#fff'}}>
                {/* Header */}
                <Box sx={{position:'relative', display:'flex', alignItems:'flex-start', gap:1.25, px:2.5, py:2, borderBottom:'1px solid #F1F2F6', flexShrink:0}}>
                    <Box sx={{width:42, height:42, borderRadius:'10px', background:'#F4DDE8', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
                        <ArticleIcon sx={{color:'#A72C68', fontSize:22}} />
                    </Box>
                    <Box sx={{flex:1, pr:3}}>
                        <Typography sx={{fontWeight:700, fontSize:'18px', color:'#1a1a2e', lineHeight:1.2, fontFamily:'helvetica-lt-std-bold,sans-serif'}}>Client Forms</Typography>
                        <Typography sx={{fontSize:'12px', color:'#8a8d97', mt:'2px'}}>Access and manage all client forms in one place.</Typography>
                    </Box>
                    <IconButton size="small" onClick={() => onPanelClose?.()} sx={{position:'absolute', top:10, right:10, color:'#9A9797','&:hover':{color:'#EB5757', background:'#ffeaea'}}}>
                        <CloseIcon sx={{fontSize:18}} />
                    </IconButton>
                </Box>

                {loading ? (
                    <Box sx={{minHeight:'200px'}}><Waveloading /></Box>
                ) : (
                    <Box ref={scrollableRef} sx={{flex:1, overflow:'auto'}}>
                        {/* Search */}
                        <Box sx={{display:'flex', gap:1, px:2.5, pt:2, pb:1.5, alignItems:'center'}}>
                            <TextField
                                fullWidth size="small" placeholder="Search forms..." value={search} onChange={handleChanges}
                                InputProps={{startAdornment: <SearchIcon sx={{color:'#a0a4ab', fontSize:18, mr:1}} />}}
                                sx={{
                                    '& .MuiOutlinedInput-root': {borderRadius:'10px', background:'#F7F8FB', '& fieldset':{borderColor:'#ECEDF2'}, '&:hover fieldset':{borderColor:'#E5A8C2'}, '&.Mui-focused fieldset':{borderColor:'#A72C68'}},
                                    '& .MuiInputBase-input': {height:'15px', py:'10px', fontSize:'13px'},
                                }}
                            />
                        </Box>

                        {/* Filter tabs */}
                        <Box sx={{display:'flex', gap:0.75, px:2.5, pb:1.5, flexWrap:'wrap'}}>
                            {tabs.map(t => {
                                const isActive = active === t.id;
                                return (
                                    <Button
                                        key={t.id}
                                        size="small"
                                        startIcon={t.icon}
                                        onClick={() => t.id === 3 ? handleSubmitted() : setActive(t.id)}
                                        sx={{
                                            borderRadius:'10px', textTransform:'none', fontSize:'12px', fontWeight:600, px:1.5, py:0.75, minWidth:0,
                                            background: isActive ? '#A72C68' : '#F3F4F8',
                                            color: isActive ? '#fff' : '#3b4252',
                                            border: isActive ? '1px solid #A72C68' : '1px solid #ECEDF2',
                                            boxShadow: isActive ? '0 2px 6px rgba(167,44,104,0.25)' : 'none',
                                            '&:hover': {background: isActive ? '#921F58' : '#EAEBF1'},
                                            '& .MuiButton-startIcon': {mr: 0.5},
                                        }}
                                    >
                                        {t.label}
                                    </Button>
                                );
                            })}
                        </Box>

                        {/* Form rows */}
                        <Box sx={{px:2.5, pb:2}}>
                            {active === 0 && (() => {
                                const consent = filteredForms || [];
                                const service = filteredCustomerForm || [];
                                const chart = filteredChartForm || [];
                                if (!consent.length && !service.length && !chart.length) return emptyMsg('No Forms Found.');
                                return <>
                                    {consent.map(f => formRow(f, 'Consent', () => onFormOpen(f), mailBtn(f)))}
                                    {service.map(f => formRow(f, 'Service', () => onFormOpen(f), mailBtn(f)))}
                                    {chart.map(f => formRow(f, 'Chart',   () => onFormOpen(f), <Box sx={{display:'flex',alignItems:'center',gap:0.5}}>{mailBtn(f)}{f?.is_submitted && <CheckCircleIcon sx={{color:'#27AE60', fontSize:18}} />}</Box>))}
                                </>;
                            })()}

                            {active === 4 && (filteredForms?.length > 0
                                ? filteredForms.map(f => formRow(f, 'Consent', () => onFormOpen(f), mailBtn(f)))
                                : emptyMsg('No Consent Form Found'))}

                            {active === 1 && (filteredCustomerForm?.length
                                ? filteredCustomerForm.map(f => formRow(f, 'Service', () => onFormOpen(f), mailBtn(f)))
                                : emptyMsg('No Customer/Service Form Found.'))}

                            {active === 2 && (filteredChartForm?.length
                                ? filteredChartForm.map(f => formRow(f, 'Chart', () => onFormOpen(f), <Box sx={{display:'flex',alignItems:'center',gap:0.5}}>{mailBtn(f)}{f?.is_submitted && <CheckCircleIcon sx={{color:'#27AE60', fontSize:18}} />}</Box>))
                                : emptyMsg('No Chart Form Found.'))}

                            {active === 3 && (
                                (filteredSubmitForm?.length || filteredSubmitCustomerForm?.length || filteredSubmitChartForm?.length)
                                    ? <>
                                        {filteredSubmitForm?.length > 0 && <>
                                            <Typography sx={{mt:'8px', mb:'8px', fontSize:'12px', fontWeight:700, color:'#8a8d97', textTransform:'uppercase', letterSpacing:'0.4px'}}>Consent Submitted</Typography>
                                            {filteredSubmitForm.map(f => formRow(f, 'Consent', () => onSubmittedOpen(f), f?.is_submitted && <Typography sx={{fontSize:'11px', fontWeight:600, color:'#555'}}>{f?.submitted_time}</Typography>))}
                                        </>}
                                        {filteredSubmitCustomerForm?.length > 0 && <>
                                            <Typography sx={{mt:'16px', mb:'8px', fontSize:'12px', fontWeight:700, color:'#8a8d97', textTransform:'uppercase', letterSpacing:'0.4px'}}>Customer Service Submitted</Typography>
                                            {filteredSubmitCustomerForm.map(f => formRow(f, 'Service', () => onSubmittedOpen(f), f?.is_submitted && <Typography sx={{fontSize:'11px', fontWeight:600, color:'#555'}}>{f?.submitted_time}</Typography>))}
                                        </>}
                                        {filteredSubmitChartForm?.length > 0 && <>
                                            <Typography sx={{mt:'16px', mb:'8px', fontSize:'12px', fontWeight:700, color:'#8a8d97', textTransform:'uppercase', letterSpacing:'0.4px'}}>Submitted Chart Form</Typography>
                                            {filteredSubmitChartForm.map(f => formRow(f, 'Chart', () => onSubmittedOpen(f), f?.is_submitted && <Typography sx={{fontSize:'11px', fontWeight:600, color:'#555'}}>{f?.submitted_time}</Typography>))}
                                        </>}
                                    </>
                                    : emptyMsg('No Forms Found.')
                            )}
                        </Box>
                    </Box>
                )}
                <LinkModal open={isModalOpen} onClose={closeModal} linkUrl={selectedLinkUrl} />
            </Box>
        );
    }

    return(
        <Box>
            <Customcolorbtn
                handleClick={() => handleFetchForm()}
                mainColor={"#A533B8"}
                style={{
                    borderRadius: "4px",  
                    padding: '10px 15px', 
                    width:fwidth,
                    fontSize: "17px !important",
                    ...crmStyle,
                    '@media (max-width:450px)':{
                        fontSize:'13px'
                    }
                }}
                val={"Client Form"}
                height={"100%"}
                  icon={isbtn ? <ArticleIcon /> : null}     
            />
            <CustomModal
                customWidth={"95%"}
                open={treatmentForm !== null}
                setOpen={() => setTreatmentForm(null)}
            >
                {
                    loading ? <Box
                            sx={{
                                minHeight: '300px',
                            }} 
                        >
                            <Waveloading/>
                        </Box> : 
                        <Box
                        ref={scrollableRef}
                            sx={{
                                minHeight: '300px',    
                                overflow: 'auto' 
                            }}
                        >
                      <Box 
                            sx={{
                            display: "flex", 
                            alignItems: 'center',
                            marginBottom:"8px",
                            justifyContent: 'center',
                           }} >


            <TextField
                 sx={{
                  width: {
    xs: "95%",
    sm: "95%",
    md: "95%",
    lg: "95%",
    xl: "95%",
  },
                    borderRadius:"22px",
                    border:"1px solid black",
                       // background: "#F5DFEA",
                       borderRadius:'4px',
                       ".MuiOutlinedInput-notchedOutline": {
                           borderWidth: "0!important"
                       },
                       ".MuiInputBase-input":{
                        
                           height: "11px",
                           minHeight: 'unset',
       
                           "&:focus":{  
                               "input":{
                                   height:'11px'
                               }
                           },
                           "&:hover":{
                               borderColor: "#F5DFEA",
                               outline: "none",
                           }
                       }
                   }}
            
                variant="outlined"
                name={""}
                // sx={inputStyle}
                placeholder={"search"}
                value={search}
                onChange={handleChanges}
              />
                            </Box>
                            {/* <Box
                                sx={{
                                    display: "flex",
                                    alignItems: 'center',
                                    gap: '20px',
                                   flexWrap:'wrap',
                                    justifyContent: 'center',
                                    mt:2
                                }}
                            >  
                                <CustomButtoncolor
                                    mainColor={"#498AEE"}
                                    active={active===4}
                                    style={{
                                        borderRadius: "4px",
                                        padding: '10px 15px',
                                    }}
                                    val={"Consent Form"}
                                    handleClick={() => setActive(4)}
                                />
                                <CustomButtoncolor
                                    active={active===1}
                                    mainColor={"#323681"}
                                    style={{borderRadius: "4px", padding: '10px 15px'}}
                                    val={"Customer/Service Form"}
                                    handleClick={() => setActive(1)}

                                /> 

                                <CustomButtoncolor
                                    mainColor={"#F6A53C"}  
                                    active={active===2}
                                    style={{borderRadius: "4px", padding: '10px 15px'}}
                                    val={"Chart Form"}
                                    handleClick={() => setActive(2)}

                                />
                                <CustomButtoncolor
                                    mainColor={"#219653"}
                                    active={active===3}
                                    style={{borderRadius: "4px", padding: '10px 15px'}}
                                    val={"Submitted Form"}
                                    handleClick={() => handleSubmitted()}

                                />   
                            </Box>       */}
                            <Grid container sx={{
                                    display: "flex",
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    mt:2,
                                    px:1,
                                }}>
                              <Grid item lg={2.5} md={2.5} sm={5.9} sx={{ mt:1 }} xs={12}>
                                    <CustomButtoncolor
                                    mainColor={"#498AEE"}
                                    active={active===4}
                                    style={{
                                        borderRadius: "4px",
                                        padding: '10px 15px',
                                    }}
                                    val={"Consent Form"}
                                     fwidth={"100%"}
                                     fsize={"12px"}
                                    handleClick={() => setActive(4)}
                                />
                              </Grid>
                              <Grid item lg={3.4} md={3.4} sm={5.9} sx={{ mt:1 }} xs={12}>
                                   <CustomButtoncolor
                                    active={active===1}
                                    mainColor={"#323681"}
                                    style={{borderRadius: "4px", padding: '10px 15px'}}
                                    val={"Customer/Service Form"}
                                     fwidth={"100%"}
                                     fsize={"12px"}
                                    handleClick={() => setActive(1)}

                                /> 
                              </Grid>
                              <Grid item lg={2.3} md={2.3} sm={5.9} sx={{ mt:1 }} xs={12}>
                                <CustomButtoncolor
                                    mainColor={"#F6A53C"}  
                                    active={active===2}
                                    style={{borderRadius: "4px", padding: '10px 15px'}}
                                    val={"Chart Form"}
                                     fwidth={"100%"}
                                     fsize={"12px"}
                                    handleClick={() => setActive(2)}

                                />

                              </Grid>
                              <Grid item lg={2.8} md={2.8} sm={5.9} sx={{ mt:1 }} xs={12}>
                                    <CustomButtoncolor
                                    mainColor={"#219653"}
                                    active={active===3}
                                    style={{borderRadius: "4px", padding: '10px 15px'}}
                                    val={"Submitted Form"}
                                    fwidth={"100%"}
                                    fsize={"12px"}
                                    handleClick={() => handleSubmitted()}

                                /> 
                              </Grid>
                            </Grid>

                            {active === 4 &&   
                                <Box> 
                                    <Typography
                                        sx={{
                                            my: '25px',
                                            fontFamily: "helvetica-lt-std-bold",
                                        }}  
                                    >  
                                        Consent Form:  
                                    </Typography>
                                    {
                                        filteredForms?.length > 0? 
                                        filteredForms.map((form, index) => (
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        background: '#F5DFEA',  
                                                        p: '5px 10px',
                                                        borderRadius: '5px',
                                                        mt: '5px',
                                                        mb: '10px',
                                                        display: 'flex',
                                                        height:{sm:'35px', xs:'auto'},
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        justifyContent:'space-between',
                                                    }}
                                                    key={index}
                                                    onClick={() => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`)}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <PlayArrow
                                                            sx={{
                                                                fontSize: '1.3rem',
                                                            }} 
                                                        />
                                                        <Typography
                                                            sx={{
                                                                ml: '10px',
                                                            }}
                                                        >
                                                            {form?.name}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <AttachEmailIcon
                                                   onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRowClick(form?.customer_id,form?.treatment_form_id)}}
                                                        sx={{
                                                            fontSize: '1.3rem',
                                                        }}
                                                    /> 
                                                </div>
                                                   {/* {
                                                        form?.is_submitted &&
                                                       <CheckCircleOutlineIcon
                                                            sx={{
                                                                color: '#27AE60',
                                                                fontSize: '1.8rem'
                                                            }}
                                                        />
                                                    }*/}
                                                </Box>
                                                </Box>
                                            )) :
                                            <Typography
                                                sx={{
                                                    fontFamily: "helvetica-lt-std-bold",
                                                    textAlign: 'center',
                                                    mt: '24px'
                                                }}
                                            >
                                                No Consent Form Found
                                            </Typography>
                                    }
                                </Box>
                            }

                            {active === 1 &&
                                <Box> 
                                    <Typography  
                                        sx={{
                                            my: '25px',
                                            fontFamily: "helvetica-lt-std-bold", 
                                        }}
                                    >   
                                        Customer/Service Form:
                                    </Typography>
                                    {   filteredCustomerForm?.length ? 
                                        filteredCustomerForm?.map((form, index) => (  
                                            <Box
                                            sx={{    
                                                width: '100%',
                                                background: '#F5DFEA',   
                                                p: '5px 10px',
                                                borderRadius: '5px', 
                                                mt: '5px',
                                                mb: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: {sm:'35px', xs:'auto'},
                                                cursor: 'pointer',
                                                justifyContent: 'space-between',
                                            }}
                                            key={index}
                                            onClick={() => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`)}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <PlayArrow
                                                    sx={{
                                                        fontSize: '1.3rem',
                                                    }}
                                                />
                                                <Typography
                                                    sx={{
                                                        ml: '10px',
                                                    }}
                                                >
                                                    {form?.name}
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <AttachEmailIcon
                                                    onClick={(e) => { 
                                                        e.stopPropagation(); 
                                                        handleRowClick(form?.customer_id,form?.treatment_form_id)} }
                                                        sx={{
                                                            fontSize: '1.3rem',
                                                        }}
                                                    /> 
                                                </div>
                                                {/*{
                                                    form?.is_submitted &&
                                                    <CheckCircleOutlineIcon
                                                        sx={{
                                                            color: '#27AE60',
                                                            fontSize: '1.8rem',
                                                            marginLeft: '10px',
                                                        }}
                                                    />
                                                }*/}
                                            </Box>
                                        </Box>
                                        
                                            )) :
                                            <Typography
                                                sx={{
                                                    fontFamily: "helvetica-lt-std-bold",
                                                    textAlign: 'center',
                                                    mt: '24px'
                                                }}
                                            >
                                                No Customer/Service Form Found.
                                            </Typography>
                                    }
                                </Box>
                            }

                            {active === 2 &&
                                <Box> 
                                    <Typography
                                        sx={{
                                            my: '25px',
                                            fontFamily: "helvetica-lt-std-bold",
                                        }}
                                    >
                                        Chart Form:
                                    </Typography>
                                    {
                                        filteredChartForm?.length ?
                                        filteredChartForm?.map((form, index) => (
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        background: '#F5DFEA',
                                                        p: '5px 10px',
                                                        borderRadius: '5px',
                                                        mt: '5px',
                                                        mb: '10px',
                                                        height:'35px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        justifyContent:'space-between',
                                                    }}
                                                    key={index}
                                                    onClick={() => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`)}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <PlayArrow
                                                            sx={{
                                                                fontSize: '1.3rem',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                ml: '10px',
                                                            }}
                                                        >
                                                            {form?.name}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <AttachEmailIcon
                                                      onClick={(e) => {
                                                        e.stopPropagation(); 
                                                        handleRowClick(form?.customer_id,form?.treatment_form_id)
                                                      }}
        
                                                        sx={{
                                                            fontSize: '1.3rem',
                                                        }}
                                                    /> 
                                                </div>
                                                    {
                                                        form?.is_submitted &&
                                                        <CheckCircleOutlineIcon
                                                            sx={{
                                                                color: '#27AE60',
                                                                fontSize: '1.8rem'
                                                            }}
                                                        />
                                                    }
                                                </Box>
                                                </Box>
                                            )) :
                                            <Typography
                                                sx={{
                                                    fontFamily: "helvetica-lt-std-bold",
                                                    textAlign: 'center',
                                                    mt: '24px'
                                                }}
                                            >
                                                No Chart Form Found.
                                            </Typography>
                                    }
                                </Box>
                            }
                            {active === 3 &&
                                <Box>
                                    <Typography
                                        sx={{
                                            my: '25px',
                                            fontFamily: "helvetica-lt-std-bold",
                                        }}
                                    >
                                       Consent Submitted Form:
                                    </Typography>
                                    {
                                        filteredSubmitForm?.length ?
                                        filteredSubmitForm?.map((form, index) => (
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        background: '#F5DFEA',
                                                        p: '5px 10px',
                                                        borderRadius: '5px',
                                                        mt: '5px', 
                                                        mb: '10px',
                                                        height:'auto',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        justifyContent:'space-between',
                                                        flexWrap:{sm:'unset', xs:'wrap'}
                                                    }}
                                                    key={index}
                                                   
                                                    onClick={() => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`)}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }} 
                                                    >
                                                        <PlayArrow
                                                            sx={{
                                                                fontSize: '1.3rem',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                ml: '10px',
                                                            }}
                                                        >
                                                            {form?.name}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <AttachEmailIcon
                                                    onClick={(e) =>{  e.stopPropagation()
                                                        handleRowClick(form?.customer_id,form?.treatment_form_id)} }
                                                        sx={{
                                                            fontSize: '1.3rem',
                                                        }}
                                                    /> 
                                                </div> */}
                                                    {
                                                        form?.is_submitted &&
                                                      /*  <CheckCircleOutlineIcon
                                                            sx={{
                                                                color: '#27AE60',
                                                                fontSize: '1.8rem'
                                                            }}
                                                        />*/
                                                        <Typography variant="subtitle1" sx={{fontFamily: "helvetica-lt-std-bold" , ml:{sm:'5px', xs:'10px'}}}>{form?.submitted_time}</Typography>

                                                    }
                                                </Box>
                                                </Box>
                                            )) :
                                            <Typography
                                                sx={{
                                                    fontFamily: "helvetica-lt-std-bold",
                                                    textAlign: 'center',
                                                    mt: '24px'
                                                }}
                                            >
                                                Empty.
                                            </Typography>
                                    }
                                    <Typography
                                        sx={{
                                            my: '25px',
                                            fontFamily: "helvetica-lt-std-bold",
                                        }}
                                    >
                                        Customer Service Submitted  Form:
                                    </Typography>
                                    {
                                        allSubmittedForm?.customer_service_form?.length ?
                                            allSubmittedForm?.customer_service_form?.map((form, index) => (
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        background: '#F5DFEA',
                                                        p: '5px 10px',
                                                        borderRadius: '5px',
                                                        mt: '5px',
                                                        mb: '10px',
                                                        height:'auto',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        justifyContent:'space-between',
                                                        flexWrap:{sm:'unset', xs:'wrap'}
                                                    }}
                                                    key={index}
                                                    // onClick={() => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`)}
                                                    onClick={() => {
                                                        handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`)
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <PlayArrow
                                                            sx={{
                                                                fontSize: '1.3rem',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                ml: '10px',
                                                            }}
                                                        >
                                                            {form?.name}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <AttachEmailIcon
                                                    onClick={(e) =>  {e.stopPropagation()
                                                     handleRowClick(form?.customer_id,form?.treatment_form_id)}}
                                                        sx={{
                                                            fontSize: '1.3rem',
                                                        }}
                                                    /> 
                                                </div> */}
                                                    {
                                                        form?.is_submitted &&
                                                       /* <CheckCircleOutlineIcon
                                                            sx={{
                                                                color: '#27AE60',
                                                                fontSize: '1.8rem'
                                                            }}
                                                        />*/
                                                        <Typography variant="subtitle1" sx={{fontFamily: "helvetica-lt-std-bold" , ml:"5px"}}>{form?.submitted_time}</Typography>

                                                    }
                                                </Box>
                                                </Box>
                                            )) :
                                            <Typography
                                                sx={{
                                                    fontFamily: "helvetica-lt-std-bold",
                                                    textAlign: 'center',
                                                    mt: '24px'
                                                }}
                                            >
                                                Empty.
                                            </Typography>
                                    }
                                    <Typography
                                        sx={{
                                            my: '25px',
                                            fontFamily: "helvetica-lt-std-bold",
                                        }}
                                    >
                                        Submitted Chart Form:
                                    </Typography>
                                    {
                                        allSubmittedForm?.chart_form?.length ?
                                            allSubmittedForm?.chart_form?.map((form, index) => (
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        background: '#F5DFEA',
                                                        p: '5px 10px',
                                                        borderRadius: '5px',
                                                        mt: '5px',
                                                        mb: '10px',
                                                        height:{sm:'35px', xs:'auto'},
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        justifyContent:'space-between',
                                                        flexWrap:{sm:'unset', xs:'wrap'}
                                                    }}
                                                    key={index}
                                                    openModal
                                                    onClick={() => {
                                                        handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}?submit=1&submitted_id=${form?.submitted_id}`)
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <PlayArrow
                                                            sx={{
                                                                fontSize: '1.3rem',
                                                            }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                ml: '10px',
                                                            }}
                                                        >
                                                            {form?.name}
                                                        </Typography>
                                                    </Box>
                                                    {
                                                        form?.is_submitted &&
                                                        /*<CheckCircleOutlineIcon
                                                            sx={{
                                                                color: '#27AE60',
                                                                fontSize: '1.8rem'
                                                            }}
                                                        />*/
                                                        <Typography variant="subtitle1" sx={{fontFamily: "helvetica-lt-std-bold"}}>{form?.submitted_time}</Typography>
                                                    }
                                                </Box>
                                            )) :
                                            <Typography
                                                sx={{
                                                    fontFamily: "helvetica-lt-std-bold",
                                                    textAlign: 'center',
                                                    mt: '24px'
                                                }}
                                            >
                                                Empty.
                                            </Typography>
                                    }
                                </Box>
                            }
                    <Box>
  <Typography  
    sx={{
      my: '25px',
      fontFamily: "helvetica-lt-std-bold",  
    }}
  >
    Search Results:
  </Typography>
  {allFilteredForms.length > 0 ?
    allFilteredForms.map((form, index) => (
        <Box
        sx={{  
            width: '100%',
            background: '#F5DFEA',     
            p: '5px 10px',  
            borderRadius: '5px',      
            mt: '5px',
            mb: '10px',
            display: 'flex',
            height:{sm:'35px', xs:'auto'},
            alignItems: 'center',
            cursor: 'pointer',
            justifyContent:'space-between',
        }}
        key={index}
        onClick={() => handleFormClick(`${window?.location?.origin}/crm/${form?.customer_id}/${form?.url}`)}
    >
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        >   
            <PlayArrow  
                sx={{     
                    fontSize: '1.3rem',
                }} 
            />  
            <Typography  
                sx={{
                    ml: '10px',
                }}
            >
                {form?.name}
            </Typography>
        </Box>
        <Box
    sx={{
        display: 'flex',
        alignItems: 'center',
    }}
>
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <AttachEmailIcon
       onClick={(e) => {
            e.stopPropagation();
            handleRowClick(form?.customer_id,form?.treatment_form_id)}}
            sx={{
                fontSize: '1.3rem',
            }}
        /> 
    </div>
       {/* { 
            form?.is_submitted &&   
           <CheckCircleOutlineIcon
                sx={{
                    color: '#27AE60',   
                    fontSize: '1.8rem'
                }}    
            />   
        }*/}  
    </Box>
    </Box>
    )) :
    <Typography>No matching forms found.</Typography>
  }
                     </Box>  
                        </Box>
                }
            </CustomModal>
            <LinkModal open={isModalOpen} onClose={closeModal} linkUrl={selectedLinkUrl} />
        </Box>
    );
});

export default TreatmentFormButtonCalendar;